module.exports = __webpack_public_path__ + "static/media/ico_arrow_down_blue.dff94d01.svg";